module.exports = __webpack_public_path__ + "static/media/blog_caro10.c7c81527.png";